<template lang="pug">
    li(
        :class="clss"
        @mouseover="hover"
        @mouseleave="blur"
    )
        .tree-item
            a(v-if="redirect" :href="href" :title="item.title" :target="target" :class="{ hasIcon: isSocialMedia }")
                span.icon.is-medium(v-if="isSocialMedia && isSocialMedia == 'fb'") 
                    svg(aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-square" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-facebook-square fa-w-14")
                        path(fill="currentColor" d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z")
                span.icon.is-medium(v-else="isSocialMedia && isSocialMedia == 'ig'") 
                    svg(aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram-square" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-instagram-square fa-w-14")
                        path(fill="currentColor" d="M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z")
                span(v-else) {{ item.title }}
            router-link(v-else :to='item.path') {{ item.title }}
            button(
                v-if="toggleEvent === 'click' && children && children.length && ( ! maxDepth || depth < maxDepth)"
            )
                i.is-open(v-if="active" @click="close")
                i.is-closed(v-else @click="open")
        tree-menu(
            v-if="children.length && ( ! maxDepth || depth < maxDepth)"
            :items="children" :depth="depth + 1" :max-depth="maxDepth"
            :show="active"
        )

</template>

<script>

export default {
    name: 'TreeMenuItem',
    data() {
        return {
            timeout: undefined,
            visible: false,
            mouseover: false,
        }
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        depth: {
            type: Number,
            required: true,
        },
        maxDepth: {
            type: Number,
        },
        toggleEvent: {
            type: String,
            required: true,
        },
        current: {
            type: Object,
        },
        delay: {
            type: Number,
            required: true,
        },
        allowMultipleActiveItems: {
            type: Boolean,
            required: true,
        },
        fullWidthThreshold: {
            type: Number,
        },
    },
    computed: {
        active() {
            if (this.allowMultipleActiveItems === true) return this.visible
            return this.visible && this.current && this.item.id === this.current.id
        },
        focused() {
            if (this.allowMultipleActiveItems === true) return this.mouseover
            return this.mouseover && this.current && this.item.id === this.current.id
        },
        redirect() {
            const view = _.get(this.item, 'page.view')
            if (view === 'Redirect' && this.hyperlink.type !== 'internal' && this.hyperlink.href) return true
            return false
        },
        hyperlink() {
            return _.get(this.item, 'page.hyperlink') || {}
        },
        href() {
            let href = false

            if (this.redirect) {
                const link = this.hyperlink.href
                switch (this.hyperlink.type) {
                    case 'external':
                        if (! _.startsWith(link, 'https://') && ! _.startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        target() {
            return _.get(this.hyperlink, 'target') || '_self'
        },
        children() {
            let children = []
            if (this.item.children && this.item.children.length) {
                children = this.item.children.filter(item => ! item.disabled && ! item.hidden)
            }

            return children
        },
        clss() {
            let value = []

            if (this.active) value.push('visible')
            if (this.focused) value.push('hover')
            if (this.children.length) value.push('has-children')
            if (this.depth === 1 && this.children.length >= this.fullWidthThreshold) value.push('full-width')

            return value
        },
        isSocialMedia() {
            let socialMediaLinks = ['facebook.com', 'instagram.com', 'twitter.com']
            if(!this.redirect) return false
            let link = this.href
            let socialMedia = undefined
            socialMediaLinks.forEach ((item, index) => {
                if( link.includes(item) ) {
                    switch (item) {
                        case 'facebook.com':
                            socialMedia = 'fb'
                            break
                        case 'instagram.com':
                            socialMedia = 'ig'
                            break
                        case 'twitter.com':
                            socialMedia = 'tw'
                            break
                        default:
                            socialMedia = undefined
                    }
                }
            })
            return socialMedia
        }
    },
    methods: {
        hover() {
            if (this.timeout) clearTimeout(this.timeout)
            if (this.toggleEvent === 'hover') {
                this.$emit('focus', this.item)
                this.visible = true
            }
            this.mouseover = true
        },
        blur() {
            this.timeout = setTimeout(() => {
                if (this.toggleEvent === 'hover') {
                    this.$emit('blur', this.item)
                    this.visible = false
                }
                this.mouseover = false
            }, this.delay);
        },
        open() {
            if (this.toggleEvent === 'click') {
                this.$emit('open', this.item)
                this.visible = true
            }
        },
        close() {
            if (this.toggleEvent === 'click') {
                this.$emit('close', this.item)
                this.visible = false
            }
        }
    }
}
</script>

<style lang="sass" scoped>
    a.hasIcon
        span
            height: 100%
            vertical-align: bottom
        svg
            height: 100%
            width: 100%
</style>
